export const API_CONFIG = {
  // Empty string uses relative URLs which are proxied by Vite dev server
  // In production/UAT, VITE_API_BASE_URL will be the full gateway URL
  baseURL: import.meta.env.VITE_API_BASE_URL || '',
  timeout: 180000, // 3 minutes - F&O sync operations can take 2+ minutes
  headers: {
    'Content-Type': 'application/json',
  },
}

export const ENDPOINTS = {
  // Auth endpoints
  auth: {
    login: '/identity/auth/login',
    azureLogin: '/identity/auth/azure-login',
    me: '/identity/auth/me',
    logout: '/identity/auth/logout',
  },
  
  // User endpoints
  users: {
    list: '/identity/users',
    create: '/identity/users',
    get: (id: string) => `/identity/users/${id}`,
    update: (id: string) => `/identity/users/${id}`,
    delete: (id: string) => `/identity/users/${id}`,
    directReports: (id: string) => `/identity/users/${id}/direct-reports`,
  },
  
  // Consolidated Performance endpoints (objectives, KPIs, strategic pillars)
  objectives: {
    list: '/performance/objectives/',
    create: '/performance/objectives/',
    get: (id: string) => `/performance/objectives/${id}`,
    update: (id: string) => `/performance/objectives/${id}`,
    delete: (id: string) => `/performance/objectives/${id}`,
  },
  
  // KPI endpoints
  kpis: {
    list: '/performance/kpis',
    create: '/performance/kpis',
    get: (id: string) => `/performance/kpis/${id}`,
    update: (id: string) => `/performance/kpis/${id}`,
    delete: (id: string) => `/performance/kpis/${id}`,
    measurements: (id: string) => `/performance/kpis/${id}/measurements`,
    milestones: (id: string) => `/performance/kpis/${id}/milestones`,
  },
  
  // Role-based KPI endpoints
  roleKpis: {
    list: (roleType: string) => `/performance/roles/${roleType}/kpis`,
    create: (roleType: string) => `/performance/roles/${roleType}/kpis`,
    get: (roleType: string, id: string) => `/performance/roles/${roleType}/kpis/${id}`,
    update: (roleType: string, id: string) => `/performance/roles/${roleType}/kpis/${id}`,
  },
  
  // Strategic Pillars endpoints
  strategicPillars: {
    list: '/performance/strategic-pillars',
    create: '/performance/strategic-pillars',
    get: (id: string) => `/performance/strategic-pillars/${id}`,
    update: (id: string) => `/performance/strategic-pillars/${id}`,
  },
  
  // Key Performance Areas endpoints
  kpas: {
    list: '/api/v1/kpas',
    create: '/api/v1/kpas',
    get: (id: string) => `/api/v1/kpas/${id}`,
    update: (id: string) => `/api/v1/kpas/${id}`,
  },
  
  // Performance cascade endpoints
  cascade: {
    visualization: '/performance/cascade',
    kpiToPillar: (kpiId: string) => `/performance/cascade/kpi/${kpiId}`,
  },
  
  // Feedback endpoints
  feedback: {
    list: '/feedback/feedback',
    create: '/feedback/feedback',
    get: (id: string) => `/feedback/feedback/${id}`,
  },
  
  // Development endpoints
  development: {
    idps: '/development/idps',
    createIdp: '/development/idps',
    getIdp: (id: string) => `/development/idps/${id}`,
    updateIdp: (id: string) => `/development/idps/${id}`,
  },
  
  // Talent endpoints
  talent: {
    calibration: '/talent/calibration',
    nineBox: '/talent/nine-box',
    succession: '/talent/succession',
  },
  
  // Analytics endpoints
  analytics: {
    dashboard: '/analytics/dashboard',
    reports: '/analytics/reports',
    export: '/analytics/export',
  },
  
  // Review cycle endpoints
  reviews: {
    userReviews: (userId: string) => `/performance/reviews/users/${userId}/review-milestones`,
    nextReview: (userId: string) => `/performance/reviews/users/${userId}/next-review`,
    teamReviews: (managerId: string) => `/performance/reviews/managers/${managerId}/team-reviews`,
  },
  
  // Evidence endpoints
  evidence: {
    list: (userId: string) => `/performance/evidence/users/${userId}/evidence`,
    create: (userId: string) => `/performance/evidence/users/${userId}/evidence`,
    get: (userId: string, evidenceId: string) => `/performance/evidence/users/${userId}/evidence/${evidenceId}`,
    update: (userId: string, evidenceId: string) => `/performance/evidence/users/${userId}/evidence/${evidenceId}`,
    updateClassification: (userId: string, evidenceId: string) => `/performance/evidence/users/${userId}/evidence/${evidenceId}/classification`,
    delete: (userId: string, evidenceId: string) => `/performance/evidence/users/${userId}/evidence/${evidenceId}`,
  },
}
